export const GET_ALL_REMINDERS = 'GET_ALL_REMINDERS';
